import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
// @mui
import {  
          Container, 
          Stack,
          Button,
          Box,
          Typography,
          TextField,
          Grid,
          Autocomplete,

} from '@mui/material';

// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

// Calendario
import { DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt-BR'; 


// api
import { getLogs, getUsuarios } from './api';

const acoes = [
  {
    id: 0,
    nome: 'Outras'
  },
  {
    id: 1,
    nome: 'Login'
  },
  {
    id: 2,
    nome: 'Inclusão'
  },
  {
    id: 3,
    nome: 'Alteração'
  },
  {
    id: 4,
    nome: 'Exclusão'
  }
]

const colecoes = [
  {
    id: 0,
    nome: 'Outras'
  },
  {
    id: 1,
    nome: 'Produtos'
  },
  {
    id: 2,
    nome: 'Kits'
  },
  {
    id: 3,
    nome: 'Clientes'
  },
  {
    id: 4,
    nome: 'Propostas'
  },
  {
    id: 5,
    nome: 'Usuarios'
  },
  {
    id: 6,
    nome: 'Metas'
  }
]

// ----------------------------

// ----------------------------------------------------------------------

export default function Logs() {
  const [logs, setLogs] = useState([])
  const [filtro, setFiltro] = useState({ data: new Date()});
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    fetchMetas(filtro)
  },[filtro])
  
  const fetchMetas = async (filtro) => {
    const result = await getLogs(filtro)
    setLogs(result)
  }

  useEffect(() => {
    fetchUsuarios()
  },[])
  const fetchUsuarios = async () => {
    const result = await getUsuarios()
    setUsuarios(result)
  }
  
  // Calendario
  const [openCalendar1, setOpenCalendar1] = useState(false);
  const handleCalendarOpen1 = () => {
    setOpenCalendar1(true);
  };
  const handleCalendarClose1 = () => {
    setOpenCalendar1(false);
  };
  const handleDateChange1 = (date) => {
    setFiltro({ ...filtro, data: date });
    handleCalendarClose1(); // Feche o calendário após a seleção da data
  };
  

  // ----------------------

  return (
    <>
      <Helmet>
        <title> Logs </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} gap={3} justifyContent={'center'}>
          <Autocomplete
            disablePortal
            id="usuario"
            value={filtro.usuario}
            onChange={(event, newValue) => {
              setFiltro({...filtro, usuario: newValue})
            }}
            options={usuarios}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            getOptionLabel={(option) => `${option.nome}`}
            sx={{width: 400, mb: 2}}
            renderInput={(params) => <TextField {...params} label="Selecione o Usuário" />}
          />

          <Autocomplete
            disablePortal
            // disabled={!JSON.parse(localStorage.getItem('userData'))?.supervisor}
            id="acao"
            value={filtro.acao}
            onChange={(event, newValue) => {
              setFiltro({...filtro, acao: newValue})
            }}
            options={acoes}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            sx={{width: 400, mb: 2}}
            renderInput={(params) => <TextField {...params} label="Selecione a Ação" />}
          />

          <Autocomplete
            disablePortal
            // disabled={!JSON.parse(localStorage.getItem('userData'))?.supervisor}
            id="acao"
            value={filtro.colecao}
            onChange={(event, newValue) => {
              setFiltro({...filtro, colecao: newValue})
            }}
            options={colecoes}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            sx={{width: 400, mb: 2}}
            renderInput={(params) => <TextField {...params} label="Selecione a Coleção" />}
          />

          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar1}
              onOpen={ handleCalendarOpen1}
              onClose={handleCalendarClose1}
              value={filtro.data}
              onChange={handleDateChange1}
              renderInput={(params) => <TextField {...params} label='Data' />}
            />
          </LocalizationProvider>

        </Stack>
        <Stack direction={'row'} justifyContent={'center'} gap={10}>
          {/* ------------ Tabela de Logs ------------ */}
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Data</TableCell>
                  <TableCell align="center">Usuário</TableCell>
                  <TableCell align="center">Ação</TableCell>
                  <TableCell align="center">Coleção</TableCell>
                  <TableCell align="left">Descrição</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.map((row,index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover':{backgroundColor:'Azure'} }}
                  >
                    <TableCell align="center">{new Date(row.data).toLocaleString('pt-BR', {  timeZone: 'America/Sao_Paulo', })}</TableCell>
                    <TableCell align="center">{row.usuario?.nome}</TableCell>
                    <TableCell align="center">{row.acao.nome}</TableCell>
                    <TableCell align="center">{row.colecao.nome}</TableCell>
                    <TableCell align="left">{row.descricao}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
        
        

      </Container>


    </>
  );
}
